import React, { useEffect, useState } from 'react';
import LoginForm from './form';
import styles from './style/index.module.less';
import {
  PageTypeLogin,
  PageTypeRegister,
  PageTypeRegisterByCaptcha,
  PageTypeResetPassword,
} from './constants';
import RegisterForm from './registForm';
import ForgetForm from './forgetForm';
import { useHistory } from 'react-router-dom';
import LoginBackground from '@/assets/login-background.png';
import LoginLogo from '@/assets/login-logo.png';
import { Image, Radio, Tabs } from '@arco-design/web-react';
import request from '@/request/request';
import CaptchaLoginForm from './captchaLoginForm';
import CaptchaRegister from './captchaRegister';
function Login() {
  const [pageType, setPageType] = useState(PageTypeLogin);
  const [subPageType, setSubPageType] = useState('1'); // 1-账密登录 2-验证码登录
  const history = useHistory();
  const params = new URLSearchParams(window.location.search);
  const [registAuthToken, setRegistAuthToken] = useState('');
  const [registMobile, setRegistMobile] = useState('');

  useEffect(() => {
    document.body.setAttribute('arco-theme', 'light');
    fetchPromotionInfo();
  }, []);

  useEffect(() => {
    const pgType = +params.get('pageType');
    setPageType(pgType || PageTypeLogin);
  }, [window.location.search]);

  const [promotionInfo, setPromotionInfo] = useState(null);
  // 检查是否有channelId，如果有要加载一下
  const fetchPromotionInfo = async () => {
    const channelId = window.localStorage.getItem('channelId');
    // if (channelId) {
    try {
      const response = await request('/apiService/mechanism/promotionInfo', {
        data: {
          channelId: channelId,
        },
        method: 'GET',
      });
      if (response.data) {
        setPromotionInfo(response.data);

        document.title = response.data.assets.seoTitle || '软件造价喵';
      }
    } catch (e) {
      console.warn('e', e);
    } finally {
    }
    // }
  };

  const getForm = () => {
    switch (pageType) {
      case PageTypeLogin:
        return (
          <div style={{ width: 340 }}>
            <Tabs
              defaultActiveTab={subPageType}
              className={styles['login-tabs']}
            >
              <Tabs.TabPane
                key={'1'}
                title={
                  <span style={{ fontSize: 16, fontWeight: 'bold' }}>
                    手机号登录
                  </span>
                }
              >
                <CaptchaLoginForm
                  userAgreemtnProtocol={
                    promotionInfo?.assets?.userAgreementProtocol
                  }
                  privacyPolicyProtocol={
                    promotionInfo?.assets?.privacyPolicyProtocol
                  }
                  onRegist={(authToken, mobile) => {
                    // 跳转url
                    history.replace({
                      pathname: '/login',
                      search: `?pageType=${PageTypeRegisterByCaptcha}`,
                    });
                    setRegistAuthToken(authToken);
                    setRegistMobile(mobile);
                    setPageType(PageTypeRegisterByCaptcha);
                  }}
                  onTypeChange={(pType) => {
                    // 跳转url
                    history.replace({
                      pathname: '/login',
                      search: `?pageType=${pType}`,
                    });
                    setPageType(pType);
                  }}
                />
              </Tabs.TabPane>
              <Tabs.TabPane
                key={'2'}
                title={
                  <span style={{ fontSize: 16, fontWeight: 'bold' }}>
                    账号密码登录
                  </span>
                }
              >
                <LoginForm
                  userAgreemtnProtocol={
                    promotionInfo?.assets?.userAgreementProtocol
                  }
                  privacyPolicyProtocol={
                    promotionInfo?.assets?.privacyPolicyProtocol
                  }
                  onTypeChange={(pType) => {
                    // 跳转url
                    history.replace({
                      pathname: '/login',
                      search: `?pageType=${pType}`,
                    });
                    setPageType(pType);
                  }}
                />
              </Tabs.TabPane>
            </Tabs>
          </div>
        );
      case PageTypeRegister:
        return (
          <RegisterForm
            channelName={promotionInfo?.name}
            onTypeChange={(pType) => {
              // 跳转url
              history.replace({
                pathname: '/login',
                search: `?pageType=${pType}`,
              });
              setSubPageType('2');
              setPageType(pType);
            }}
          />
        );
      case PageTypeResetPassword:
        return (
          <ForgetForm
            onTypeChange={(pType) => {
              // 跳转url
              history.replace({
                pathname: '/login',
                search: `?pageType=${pType}`,
              });
              setSubPageType('2');
              setPageType(pType);
            }}
          />
        );
      case PageTypeRegisterByCaptcha:
        return (
          <CaptchaRegister
            channelName={promotionInfo?.name}
            authToken={registAuthToken}
            mobile={registMobile}
            onTypeChange={(pType) => {
              // 跳转url
              history.replace({
                pathname: '/login',
                search: `?pageType=${pType}`,
              });
              setSubPageType('1');
              setPageType(pType);
            }}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url(${LoginBackground})`,
      }}
    >
      <div className={styles.banner}>
        <div className={styles['banner-inner']}>
          <Image src={LoginLogo} width={800} preview={false} />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles['content-logo']}>
          {promotionInfo?.logo && (
            <Image
              // src={Logo}
              src={promotionInfo?.logo}
              preview={false}
              style={{
                width: 250,
                height: 75,
                display: 'flex',
              }}
            />
          )}
        </div>
        <div className={styles['content-inner']}>
          {getForm()}
          {/* {pageType == PageTypeLogin ? (
            <LoginForm
              onTypeChange={(pType) => {
                // 跳转url
                history.replace({
                  pathname: '/login',
                  search: `?pageType=${pType}`,
                });
                setPageType(pType);
              }}
            />
          ) : pageType == PageTypeRegister ? (
            <RegisterForm
              channelName={promotionInfo?.name}
              onTypeChange={(pType) => {
                // 跳转url
                history.replace({
                  pathname: '/login',
                  search: `?pageType=${pType}`,
                });
                setPageType(pType);
              }}
            />
          ) : (
            <ForgetForm
              onTypeChange={(pType) => {
                // 跳转url
                history.replace({
                  pathname: '/login',
                  search: `?pageType=${pType}`,
                });
                setPageType(pType);
              }}
            />
          )} */}
        </div>
        {/* <div className={styles.footer}>
          <Footer />
        </div> */}
      </div>
    </div>
  );
}
Login.displayName = 'LoginPage';

export default Login;
